import React from 'react';
import useGame from '@monorepo/shared/src/hooks/use-game';
import { SoundOutWordsPage } from '@monorepo/shared/src/graph/schema-generated-types-educator';
import Sentence from './Sentence';
import PageNumber from './PageNumber';
import makeStyles from '@mui/styles/makeStyles';

const ActivityHeader: React.FC = () => {
  const classes = useStyles();
  const [{ currentData }] = useGame<SoundOutWordsPage>();

  return (
    <div className={classes.header}>
      {currentData.map((pageData, index) => {
        const sentence = pageData?.contents?.description ?? '';
        const isNotLastItem = index < currentData.length - 1;
        const indexOffset =
          index &&
          currentData
            .slice(0, index)
            .map((data) => data?.contents?.description)
            .join()
            .split(' ').length;

        return (
          <div key={index} className={classes.pageHeader}>
            <div className={classes.pageNumber}>
              <PageNumber pageNumber={pageData?.page?.pageNumber} />
            </div>
            <div className={`${classes.sentence} ${isNotLastItem ? classes.divider : ''}`}>
              <Sentence sentence={sentence} indexOffset={indexOffset} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ActivityHeader;

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
  },
  pageHeader: {
    flex: 1,
    display: 'flex',
    minHeight: '5vw',
    alignItems: 'center',
    borderBottom: `1px solid #f4f4f4`,
  },
  pageNumber: {
    flexShrink: 0,
  },
  sentence: {
    flex: 1,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: `${theme.typography.pxToRem(12)} 0`,
  },
  divider: {
    borderRight: `1px solid #f4f4f4`,
  },
}));
